<template>
  <div
    class="soha-last-card min-h-140px"
    @click="$emit('click')"
  >
    <div class="soha-last-card-content-center">
      <soha-button-icon
        name="lastCardBtn"
        :icon="icon"
        border-color="secondary"
        border-size="3"
        icon-color="secondary"
        border-radius="13"
      />
      <b class="soha-last-card-text">
        {{ text }}
      </b>
    </div>
  </div>
</template>

<script>
import "@/assets/css/components/base/last-card.css";
export default {
  name: "LastCard",

  props: {
    icon: String,
    text: String,
  },
};
</script>
